import {userPreferencesApiLink} from "@pg-mono/services-api-routes";

import {msStoreApi} from "../../app/api/ms_store_api";
import {isServer, msStoreJsServerApiUrl} from "../../app/read_rp_environment_variables";
import {IUserPreferences} from "../interfaces/IUserPreferences";

export const getUserPreferences = msStoreApi.injectEndpoints({
    endpoints: (build) => ({
        getUserPreferences: build.query<IUserPreferences | null, void>({
            query: () => {
                const url = userPreferencesApiLink.userPreferences.base(isServer ? msStoreJsServerApiUrl : null);
                return {
                    url,
                    method: "GET"
                };
            },
            transformResponse: (response: {filters: Record<string, number | number[]>} | null): IUserPreferences | null => {
                return response || null;
            },
            providesTags: ["UserPreferences"]
        })
    })
});

export const {useGetUserPreferencesQuery} = getUserPreferences;
import {userPreferencesApiLink} from "@pg-mono/services-api-routes";

import {msStoreApi} from "../../app/api/ms_store_api";
import {isServer, msStoreJsServerApiUrl} from "../../app/read_rp_environment_variables";
import {IUserPreferences} from "../interfaces/IUserPreferences";

export const getUserPreferences = msStoreApi.injectEndpoints({
    endpoints: (build) => ({
        getUserPreferences: build.query<IUserPreferences | null, void>({
            query: () => {
                const url = userPreferencesApiLink.userPreferences.base(isServer ? msStoreJsServerApiUrl : null);
                return {
                    url,
                    method: "GET"
                };
            },
            transformResponse: (response: {filters: Record<string, number | number[]>} | null): IUserPreferences | null => {
                return response || null;
            },
            providesTags: ["UserPreferences"]
        })
    })
});

export const {useGetUserPreferencesQuery} = getUserPreferences;
